import React, { useState, useEffect, useRef, act } from "react";
import MasterTable from "../common/MasterTable";
import CustomerModal from "../customer/CustomerModal";
import CustomAlert from "../../helpers/CustomAlert";
import { toast } from "react-toastify";
import { axiosGetApi, axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import Loader from "../Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import AddCustomerTabs from "./AddCustomerTabs/AddCustomerTabs";
import confetti from "canvas-confetti";
import CustAuditModal from "./CustAuditModal";
import CustFilterModal from "./CustFilterModal";
import ViewBalanceModal from "./ViewBalanceModal";
import OptionsModal from "./OptionsModal";
import ServicesPermissionModal from "./ServicesPermissionModal";
import TopUpSmsRcsModal from "./TopUpSmsRcsModal";
import TopUpWhatsAppModal from "./TopUpWhatsAppModal";
import ClawbackSmsRcsModal from "./ClawbackSmsRcsModal";
import ChangePartnerRateModal from "./ChangePartnerRateModal";
import ClawbackWhatsAppModal from "./ClawbackWhatsAppModal";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { setBalance } from "../store/balance/balanceSlice";
import RCSAgentDetailsModal from "./RCSAgentDetailsModal";
import RCSCallbackURLModal from "./RCSCallbackURLModal";
import { isPartnerRole } from "../../utils";

const defaultFilterData = {
  customerCode: "",
  gstNumber: "",
  status: "",
  fromDate: "",
  toDate: "",
  companyPanNumber: "",
  firstContactPersonMobileNo: "",
  assignedVendorCode: "",
};

const CustomerMaster = () => {
  const optionRefs = useRef({});

  const { user } = useSelector((state) => state.auth);

  const pageSize = 10;
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [customerData, setCustomerData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageDetails, setPageDetails] = useState(null);
  const loggedInUserName = sessionStorage.getItem("username");
  const loggedInUserCode = sessionStorage.getItem("userCode");
  const [currentPage, setCurrentPage] = useState(1);
  const [auditData, setAuditData] = useState("");
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isServiceAuthModalOpen, setIsServiceAuthModalOpen] = useState(false);
  const [filterData, setFilterData] = useState(defaultFilterData);

  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0 });
  const [isViewBalanceModalOpen, setIsViewBalanceModalOpen] = useState(false);
  const [columnData, setColumnData] = useState("");
  const [isRcsCallbackModalOpen, setIsRcsCallbackModalOpen] = useState(false);
  const [rcsCallbackData, setRcsCallbackData] = useState(null);

  const dispatch = useDispatch();

  const handleReset = () => {
    setFilterData(defaultFilterData);
  };

  const [authData, setAuthData] = useState(null);

  const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
  const [isTopUpModalOpen, setIsTopUpModalOpen] = useState(false);
  const openModalCreate = () => {
    setIsModalOpenCreate(true);
  };

  const closeModalCreate = () => {
    setIsModalOpenCreate(false);
  };

  const openTopUpModal = () => {
    setIsTopUpModalOpen(true);
  };

  const closeTopUpModal = () => {
    setIsTopUpModalOpen(false);
  };

  const [isWaTopUpModalOpen, setIsWaTopUpModalOpen] = useState(false);
  const openWaTopUpModal = () => {
    setIsWaTopUpModalOpen(true);
  };
  const closeWaTopUpModal = () => {
    setIsWaTopUpModalOpen(false);
  };

  const [isClawbackModalOpen, setIsClawbackModalOpen] = useState(false);
  const openClawbackModal = () => {
    setIsClawbackModalOpen(true);
  };
  const closeClawbackModal = () => {
    setIsClawbackModalOpen(false);
  };

  const [isWaClawbackModalOpen, setIsWaClawbackModalOpen] = useState(false);
  const openWaClawbackModal = () => {
    setIsWaClawbackModalOpen(true);
  };
  const closeWaClawbackModal = () => {
    setIsWaClawbackModalOpen(false);
  };

  const [isChangePartnerRateModalOpen, setIsChangePartnerRateModalOpen] =
    useState(false);
  const openChangePartnerRateModal = () => {
    setIsChangePartnerRateModalOpen(true);
  };
  const closeChangePartnerRateModal = () => {
    setIsChangePartnerRateModalOpen(false);
  };

  const [isModalOpenAudit, setIsModalOpenAudit] = useState(false);
  const openModalAudit = () => {
    setIsModalOpenAudit(true);
  };

  const closeModalAudit = () => {
    setIsModalOpenAudit(false);
  };

  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const [isRcsAgentModalOpen, setIsRcsAgentModalOpen] = useState(false);
  const [rcsAgentData, setRcsAgentData] = useState(null);

  const handleAuditData = (data) => {
    let custData = customerData.find((item) => item?.id === data?.id);
    console.log("custData", custData);
    fetchCustAudit(custData);
  };

  const fetchCustAudit = async (custData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        userCode: custData.customerCode,
      };

      const response = await axiosPostApi(
        `${apiList.CUST_AUDIT_DATA}`,
        requestBody,
      );
      console.log("FetchCustAudit", response);

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setAuditData(response?.data?.data?.auditData);
        openModalAudit(auditData);
        setLoading(false);
      } else {
        setLoading(false);
        CustomAlert({
          title: "Error",
          text: response?.data?.message || "Failed to fetch audit data.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomerData(1, filterData);
  }, []);

  const fetchCustomerData = async (currentPage, filters = filterData) => {
    setLoading(true);

    try {
      const requestBody = {
        username: loggedInUserName,
        customerCode: filters.customerCode || "",
        gstNumber: filters.gstNumber || "",
        status: filters.status || [],
        fromDate: formatDate(filters.fromDate),
        toDate: formatDate(filters.toDate),
        companyPanNumber: filters.companyPanNumber || "",
        firstContactPersonMobileNo: filters.firstContactPersonMobileNo || "",
        assignedVendorCode: filters.assignedVendorCode || "",
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_CUSTOMER_DATA}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody,
      );
      console.log("FetchCustresponse", response);

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setLoading(false);

        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setCustomerData(modifiedData);
        console.log("Modified customerData:", modifiedData);
        fetchDashboardData();
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setLoading(false);

        setNoData(true);
        setCustomerData([]);
      }
    } catch (error) {
      setLoading(false);

      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const modifyStructure = (response) => {
    return (
      response &&
      response?.map((customer, index) => ({
        ...customer,
        id: index + 1,
        address:
          customer.address1 +
          ", " +
          customer.address2 +
          ", " +
          customer.address3,
        mainWalletBalance: customer.mainWalletBalance || 0,
        smsBalance: customer.smsBalance || 0,
        rcsBalance: customer.rcsBalance || 0,
        waBalance: customer.waBalance || 0,
        waMarketingRate: customer.waMarketingRate || 0,
        waUtilityRate: customer.waUtilityRate || 0,
        waAuthenticationRate: customer.waAuthenticationRate || 0,
        option: "option",
      }))
    );
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    // setLoading(true);

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
        } else {
          // Handle error case here if necessary
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  const customerHeader = [
    "Company Id",
    "Company Name",
    "Company Type",
    "Status",
    "Remark",
    "Company Email Id",
    "Address",
    "Contact Person Name",
    "Contact Person Mobile No",
    "Bank Name",
    "Account Number",
    "IFSC Code",
    "GST Number",
    "Company Pan",
    "PAN Number",
    "Aadhar Number",
    "SMS Rate",
    "RCS Promotional Rate",
    "RCS Utility Rate",
    "Option",
  ];

  const customerHeaderToKeyMap = {
    Status: "authStatus",
    Remark: "adminRemark",
    "Company Id": "customerCode",
    "Company Name": "name",
    "Company Type": "companyType",
    "Company Email Id": "emailId",
    Address: "address",
    "Contact Person Name": "firstContactPersonName",
    "Contact Person Mobile No": "firstContactPersonMobileNo",
    "Bank Name": "bankName",
    "Account Number": "accountNo",
    "IFSC Code": "ifscCode",
    "GST Number": "gstNumber",
    "Company Pan": "companyPanNumber",
    "PAN Number": "panNumber",
    "Aadhar Number": "aadharNumber",
    "SMS Rate": "rate",
    "RCS Promotional Rate": "rcsRate",
    "RCS Utility Rate": "rcsUtlRate",
  };

  const handleAuthorization = (data) => {
    setAuthData(data);
    // setIsAuthModalOpen(true);
    // setIsModalOpenCreate(true);
  };

  const handleAuthSubmit = async (action, remarks) => {
    let status;
    let actionText;

    // Map the action to the correct status code
    switch (action) {
      case "approve":
        status = "1";
        actionText = "authorized";
        break;
      case "block":
        status = "3";
        actionText = "blocked";
        break;
      case "reject":
        status = "5";
        actionText = "rejected";
        break;
      default:
        status = "5";
        actionText = "rejected";
    }

    const requestBody = {
      username: loggedInUserName,
      customerCode: authData?.customerCode || "",
      status: status,
      adminRemark: remarks || "",
    };

    try {
      const response = await axiosPostApi(
        apiList.AUTH_CUSTOMER_DATA,
        requestBody,
      );
      if (response?.status === 200 && response?.data?.respCode === "00") {
        CustomAlert({
          title: "Success",
          text: `Company ${actionText} successfully!`,
          icon: "success",
          confirmButtonText: "Ok",
        });

        // Show confetti only for approval
        if (action === "approve") {
          const canvas = document.createElement("canvas");
          canvas.style.position = "fixed";
          canvas.style.top = "0";
          canvas.style.left = "0";
          canvas.style.width = "100%";
          canvas.style.height = "100%";
          canvas.style.zIndex = "3000";
          document.body.appendChild(canvas);

          const confettiInstance = confetti.create(canvas, {
            resize: true,
            useWorker: true,
          });

          confettiInstance({
            particleCount: 250,
            spread: 100,
            origin: { y: 0.6 },
          });

          setTimeout(() => {
            document.body.removeChild(canvas);
          }, 3000);
        }

        fetchCustomerData(1, filterData); // Pass filterData to maintain filters
      } else {
        CustomAlert({
          title: `Failed to ${actionText} customer`,
          text:
            response.data?.message || "Invalid credentials. Please try again!",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      console.error(`Error ${actionText} customer`, error);
      toast.error(`Failed to ${actionText} customer.`);
    }

    setIsAuthModalOpen(false);
    setAuthData(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction("");
  };

  const handleRcsCallbackUrl = (data) => {
    const custData = customerData.find((item) => item?.id === data?.id);
    if (custData) {
      setRcsCallbackData(custData);
      setIsRcsCallbackModalOpen(true);
    }
  };

  const handleCustomer = (data, actionType = "view") => {
    if (
      actionType === "modify" &&
      loggedInUserCode === data?.customerCode
    ) {
      CustomAlert({
        title: "Not Allowed",
        text: "You cannot modify your own company details.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    setModalAction(actionType);
    if (actionType === "add") {
      setEditData({});
      openModalCreate(true);
    } else if (actionType === "auth") {
      let custData = customerData.find((item) => item?.id === data?.id);

      if (custData) {
        setEditData(custData);
        setIsModalOpenCreate(true);
      }
    } else if (actionType === "moreOptions") {
      const custData = customerData.find((item) => item?.id === data?.id);
      const refEl = optionRefs.current[data?.id];

      if (custData && refEl) {
        const rect = refEl.getBoundingClientRect();
        setAnchorPosition({
          top: rect.bottom + window.scrollY + 5,
          left: rect.left + window.scrollX - 120,
        });
        setSelectedItem(custData);
        setIsOptionsOpen(true);
      } else {
        console.warn("Missing DOM reference or data for moreOptions");
      }
    } else if (actionType === "authorization") {
      setIsServiceAuthModalOpen(true);
      setColumnData(data);
    } else if (actionType === "rcsCallbackUrl") {
      handleRcsCallbackUrl(data);
    } else if (actionType === "topup") {
      openTopUpModal();
      setEditData(data);
      setColumnData(data);
    } else if (actionType === "topupWa") {
      openWaTopUpModal();
      setEditData(data);
      setColumnData(data);
    } else if (actionType === "clawback") {
      openClawbackModal();
      setEditData(data);
      setColumnData(data);
    } else if (actionType === "clawbackWa") {
      openWaClawbackModal();
      setEditData(data);
      setColumnData(data);
    } else if (actionType === "changePartnerRate") {
      openChangePartnerRateModal();
      setEditData(data);
      setColumnData(data);
    } else {
      let custData = customerData.find((item) => item?.id === data?.id);

      if (custData) {
        setEditData(custData);
        openModalCreate(true);
      }
    }
  };

  const handleCloseOptions = () => {
    setIsOptionsOpen(false);
    setSelectedItem(null);
    setAnchorPosition({ top: 0, left: 0 });
  };

  const handleOptionSelect = (option) => {
    console.log("Selected option:", option, "for item:", selectedItem);

    if (option === "View Balance") {
      // Step 1: Close OptionsModal
      setIsOptionsOpen(false);

      // Step 2: Open ViewBalanceModal
      setIsViewBalanceModalOpen(true);

      // You may also want to scroll or focus, depending on UX
      console.log("Opening ViewBalanceModal for item:", selectedItem);
    } else {
      alert(`Selected ${option} for ${selectedItem.name}`);
    }
  };

  const handleCloseViewBalanceModal = () => {
    console.log("Closing ViewBalanceModal");
    setIsViewBalanceModalOpen(false);
  };

  const handleAuthKey = (authData) => {
    CustomAlert({
      title: "SMS Key",
      text: authData.authKey,
      icon: "info",
      confirmButtonText: "Okay",
    });
  };

  const handleRechargeKey = (authData) => {
    CustomAlert({
      title: "Recharge Key",
      text: authData?.rechargeKey || "No recharge key available",
      icon: "info",
      confirmButtonText: "Okay",
    });
  };

  const handlePaymentKey = (authData) => {
    CustomAlert({
      title: "Bill Payment Key",
      text: authData?.billPaymentKey || "No bill payment key available",
      icon: "info",
      confirmButtonText: "Okay",
    });
  };

  const handleCourier = (authData) => {
    CustomAlert({
      title: "Courier Key",
      text: authData?.courierServiceKey || "No courier service key available",
      icon: "info",
      confirmButtonText: "Okay",
    });
  };

  const handleRcsKey = async (authData) => {
    try {
      const response = await axiosGetApi(
        `${apiList.GET_RCS_AGENT_ID}/${authData?.customerCode}`,
      );

      const responseData = response?.data?.data || "";
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        CustomAlert({
          title: "RCS Key",
          text: responseData?.rcsAgentId,
          icon: "info",
          confirmButtonText: "Okay",
        });
      } else {
        CustomAlert({
          title: "Error",
          text: response?.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const fetchRcsAgentDetails = async (custData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        companyName: custData.name,
      };

      const response = await axiosPostApi(apiList.FETCH_RCS_AGENT, requestBody);

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "200"
      ) {
        setRcsAgentData({
          rcsAgentId: response?.data?.data?.rcsAgentId || "",
          companyName: custData.name,
          agentId: response?.data?.data?.agentId || "",
          agentApiKey: response?.data?.data?.agentApiKey || "",
          apiKey: response?.data?.data?.apiKey || "",
          status: response?.data?.data?.status || "",
          customerCode: custData.customerCode,
        });
        setIsRcsAgentModalOpen(true);
        setLoading(false);
      } else {
        setLoading(false);
        CustomAlert({
          title: "Error",
          text: response?.data?.message || "Failed to fetch RCS agent details.",
          icon: "warning",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleRcsAgentDetails = (data) => {
    fetchRcsAgentDetails(data);
  };

  const handleUpdateRcsAgent = async (updatedData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        rcsAgentId: rcsAgentData.rcsAgentId,
        companyName: updatedData.companyName || rcsAgentData.companyName,
        agentId: updatedData.agentId || "",
        agentApiKey: updatedData.agentApiKey || "",
        apiKey: updatedData.apiKey || "",
        status: updatedData.status || "",
      };

      const response = await axiosPostApi(
        apiList.MODIFY_RCS_AGENT,
        requestBody,
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "200"
      ) {
        CustomAlert({
          title: "Success",
          text: "RCS Agent Details updated successfully!",
          icon: "success",
          confirmButtonText: "Ok",
        });
        setIsRcsAgentModalOpen(false);
        fetchCustomerData(currentPage, filterData);
      } else {
        CustomAlert({
          title: "Error",
          text:
            response?.data?.message || "Failed to update RCS agent details.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while updating the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <MasterTable
              loading={loading}
              headers={customerHeader}
              data={customerData}
              handleAction={handleCustomer}
              handleKey={handleAuthKey}
              RechargeKey={handleRechargeKey}
              BillPaymentKey={handlePaymentKey}
              CourierKey={handleCourier}
              handleRcsKey={handleRcsKey}
              filterFields={["name"]}
              entityType="Company"
              headerToKeyMap={customerHeaderToKeyMap}
              handleAuth={handleAuthorization}
              noData={noData}
              pageDetails={pageDetails}
              currentPage={currentPage}
              pageSize={pageSizeCount}
              totalRecord={totalRecord}
              fetchNextData={(page) => fetchCustomerData(page, filterData)}
              setCurrentPage={setCurrentPage}
              handleAuditData={handleAuditData}
              openModalFilter={openModalFilter}
              handleReset={handleReset}
              filterData={filterData}
              fetchData={() => fetchCustomerData(1, defaultFilterData)}
              optionRefs={optionRefs}
              handleRcsAgentDetails={handleRcsAgentDetails}
              handleRcsCallbackUrl={handleRcsCallbackUrl}
            />

            <CustomerModal
              show={showModal}
              handleClose={handleCloseModal}
              editData={editData}
              action={modalAction}
              fetchCustomerData={fetchCustomerData}
            />
          </>
        )}

        {isModalOpenCreate ? (
          <AddCustomerTabs
            openCreate={isModalOpenCreate}
            show={openModalCreate}
            CloseCreate={closeModalCreate}
            editData={editData}
            action={modalAction}
            fetchCustomerData={fetchCustomerData}
            minSmsRate={
              isPartnerRole() ? customerData?.[0]?.partnerSmsRate : undefined
            }
            minRcsRate={
              isPartnerRole() ? customerData?.[0]?.partnerRcsRate : undefined
            }
            minRcsUtlRate={
              isPartnerRole()
                ? customerData?.[0]?.partnerRcsUtlRate
                : undefined
            }
          />
        ) : null}
        {isModalOpenFilter ? (
          <CustFilterModal
            show={isModalOpenFilter}
            handleClose={closeModalFilter}
            auditData={auditData}
            setCustomerData={setCustomerData}
            setPageDetails={setPageDetails}
            setNoData={setNoData}
            currentPage={currentPage}
            pageSize={pageSize}
            filterData={filterData}
            setFilterData={setFilterData}
            handleReset={handleReset}
          />
        ) : null}

        {isModalOpenAudit ? (
          <CustAuditModal
            show={isModalOpenAudit}
            handleClose={closeModalAudit}
            auditData={auditData}
          />
        ) : null}

        {isAuthModalOpen && (
          <AuthorizationConfirmationModal
            show={isAuthModalOpen}
            handleClose={() => setIsAuthModalOpen(false)}
            handleSubmit={handleAuthSubmit}
          />
        )}
        {isOptionsOpen && selectedItem && (
          <OptionsModal
            open={isOptionsOpen}
            handleClose={handleCloseOptions}
            item={selectedItem}
            anchorPosition={anchorPosition}
            onSelect={handleOptionSelect}
          />
        )}

        {isViewBalanceModalOpen && selectedItem && (
          <ViewBalanceModal
            show={isViewBalanceModalOpen}
            handleClose={handleCloseViewBalanceModal}
            item={selectedItem}
          />
        )}

        {isServiceAuthModalOpen && (
          <ServicesPermissionModal
            isOpen={isServiceAuthModalOpen}
            onClose={() => setIsServiceAuthModalOpen(false)}
            columnData={columnData}
            callApi={() => fetchCustomerData(currentPage)}
          />
        )}

        {isTopUpModalOpen && (
          <TopUpSmsRcsModal
            show={isTopUpModalOpen}
            handleClose={() => setIsTopUpModalOpen(false)}
            callApi={() => fetchCustomerData(currentPage)}
            editData={editData}
            action={modalAction}
            columnData={columnData}
          />
        )}

        {isWaTopUpModalOpen && (
          <TopUpWhatsAppModal
            show={isWaTopUpModalOpen}
            handleClose={() => setIsWaTopUpModalOpen(false)}
            callApi={() => fetchCustomerData(currentPage)}
            editData={editData}
            action={modalAction}
            columnData={columnData}
          />
        )}

        {isClawbackModalOpen && (
          <ClawbackSmsRcsModal
            show={isClawbackModalOpen}
            handleClose={() => setIsClawbackModalOpen(false)}
            callApi={() => fetchCustomerData(currentPage)}
            editData={editData}
            action={modalAction}
            columnData={columnData}
          />
        )}

        {isChangePartnerRateModalOpen && (
          <ChangePartnerRateModal
            show={isChangePartnerRateModalOpen}
            handleClose={closeChangePartnerRateModal}
            callApi={() => fetchCustomerData(currentPage)}
            columnData={columnData}
          />
        )}

        {isWaClawbackModalOpen && (
          <ClawbackWhatsAppModal
            show={isWaClawbackModalOpen}
            handleClose={() => setIsWaClawbackModalOpen(false)}
            callApi={() => fetchCustomerData(currentPage)}
            editData={editData}
            action={modalAction}
            columnData={columnData}
          />
        )}

        {isRcsAgentModalOpen && rcsAgentData && (
          <RCSAgentDetailsModal
            show={isRcsAgentModalOpen}
            handleClose={() => setIsRcsAgentModalOpen(false)}
            rcsAgentData={rcsAgentData}
            onSubmit={handleUpdateRcsAgent}
            readOnly={loggedInUserCode === rcsAgentData?.customerCode}
          />
        )}

        {isRcsCallbackModalOpen && rcsCallbackData && (
          <RCSCallbackURLModal
            show={isRcsCallbackModalOpen}
            handleClose={() => {
              setIsRcsCallbackModalOpen(false);
              setRcsCallbackData(null);
            }}
            customerData={rcsCallbackData}
            fetchCustomerData={() => fetchCustomerData(currentPage, filterData)}
          />
        )}
      </div>
    </>
  );
};

const AuthorizationConfirmationModal = ({
  show,
  handleClose,
  handleSubmit,
}) => {
  const [action, setAction] = useState("approve");
  const [adminRemark, setRemarks] = useState("");
  const [error, setError] = useState("");

  if (!show) return null;

  const validateRemark = (remark) => {
    // Check for blank input
    if (!remark.trim()) {
      return "Remark is required";
    }

    // Minimum length check
    if (remark.trim().length < 3) {
      return "Remark must be at least 3 characters long";
    }

    // Maximum length check
    if (remark.length > 255) {
      return "Remark cannot exceed 255 characters";
    }

    // Allowed characters: letters, numbers, punctuation (.,!@#&()-), and spaces
    const allowedCharsRegex = /^[a-zA-Z0-9.,!@#&()\-\s]+$/;
    if (!allowedCharsRegex.test(remark)) {
      return "Remark can only contain letters, numbers, punctuation (.,!@#&()-), and spaces";
    }

    // Disallow only special characters (e.g., !!!@@@ without text)
    const onlySpecialCharsRegex = /^[.,!@#&()\-\s]+$/;
    if (onlySpecialCharsRegex.test(remark)) {
      return "Remark cannot consist of only special characters";
    }

    // Disallow HTML tags to prevent injection
    const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;
    if (htmlTagRegex.test(remark)) {
      return "HTML tags are not allowed in the remark";
    }

    // Basic profanity filter (example with a few common offensive words)
    const profanityList = ["damn", "hell", "idiot", "stupid"];
    const remarkLower = remark.toLowerCase();
    for (const word of profanityList) {
      if (remarkLower.includes(word)) {
        return "Profanity is not allowed in the remark";
      }
    }

    return "";
  };

  const onSubmit = () => {
    if (!adminRemark.trim()) {
      setError("Remark is required");
      return;
    }
    setError("");
    handleSubmit(action, adminRemark);
  };

  const handleRemarkChange = (e) => {
    setRemarks(e.target.value);
    if (error && e.target.value.trim()) {
      setError("");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "50px",
          borderRadius: "40px",
          width: "90%",
          maxWidth: "600px",
          textAlign: "center",
        }}
      >
        <h3 style={{ fontWeight: "bold", fontSize: "24px", color: "#1A202C" }}>
          Are you sure?
        </h3>
        <p
          style={{
            color: "#1A202C",
            fontSize: "18px",
            fontWeight: "normal",
            marginTop: "10px",
          }}
        >
          Do you want to authorize the company?
        </p>

        <div
          style={{
            margin: "20px 0",
            display: "flex",
            justifyContent: "center",
            gap: "40px",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "16px",
              color: "#1A202C",
            }}
          >
            <input
              type="radio"
              value="approve"
              checked={action === "approve"}
              onChange={() => setAction("approve")}
              style={{
                width: "20px",
                height: "20px",
                accentColor: "#00C4B4",
              }}
            />
            Approve
          </label>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "16px",
              color: "#1A202C",
            }}
          >
            <input
              type="radio"
              value="reject"
              checked={action === "reject"}
              onChange={() => setAction("reject")}
              style={{
                width: "20px",
                height: "20px",
                accentColor: action === "reject" ? "red" : "#00C4B4",
              }}
            />
            Reject
          </label>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label
            style={{
              display: "block",
              textAlign: "left",
              fontSize: "16px",
              color: "#1A202C",
            }}
          >
            Remark <span style={{ color: "red" }}>*</span>
          </label>
          <textarea
            placeholder="Enter your remarks here..."
            value={adminRemark}
            onChange={handleRemarkChange}
            style={{
              width: "100%",
              height: "100px",
              border: "1px solid #00C4B4",
              borderRadius: "10px",
              padding: "5px",
              boxSizing: "border-box",
              fontSize: "14px",
              color: "#A0AEC0",
            }}
          />
          {error && (
            <p
              style={{
                color: "red",
                fontSize: "14px",
                textAlign: "left",
                marginTop: "5px",
              }}
            >
              {error}
            </p>
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <button
            onClick={handleClose}
            style={{
              padding: "10px",
              width: "120px",
              border: "1px solid #00C4B4",
              borderRadius: "20px",
              backgroundColor: "white",
              color: "#00C4B4",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            style={{
              padding: "10px",
              width: "120px",
              border: "none",
              borderRadius: "20px",
              backgroundColor: "#0dcaf0",
              color: "white",
              cursor: "pointer",
              fontSize: "16px",
              transition: "background-color 0.3s, color 0.3s, border 0.3s",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "#0dcaf0";
              e.target.style.border = "1px solid #0dcaf0";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#0dcaf0";
              e.target.style.color = "white";
              e.target.style.border = "none";
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerMaster;
